// @flow

import { put, call, all, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";

import http from "@http";
import { sendSuccessMessage } from "@modules/app/actionCreator";
import * as actions from "@modules/service/constants/actions";
import actionCreators from "@modules/service/actionCreator";
import type { ManagerSmsSettings } from "@modules/service/reducer/manager-sms-notifications/types";

type GetManagerSmsSettingsRequest = $Exact<{
  clientId: string,
}>;

export function* onGetManagerSmsNotificationSettings({
  payload,
}: Action<GetManagerSmsSettingsRequest>): Generator<*, void, { data: ManagerSmsSettings }> {
  try {
    if (!payload || !payload.clientId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `/api/v2/service-admin/client/${payload.clientId}/service-config/absence-management/manager-sms-notifications`,
    );

    yield put(actionCreators.GetManagerSmsNotificationSettingsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetManagerSmsNotificationSettingsError(e.response));
  }
}

type UpdateManagerSmsSettingsRequest = $Exact<{
  clientId: string,
  settings: ManagerSmsSettings,
  successMessage: string,
}>;

export function* onUpdateManagerSmsSettings({
  payload,
}: Action<UpdateManagerSmsSettingsRequest>): Generator<*, void, { data: ManagerSmsSettings }> {
  try {
    if (!payload || !payload.clientId || !payload.settings || !payload.successMessage) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.put,
      `/api/v2/service-admin/client/${payload.clientId}/service-config/absence-management/manager-sms-notifications`,
      payload.settings,
    );

    yield all([
      put(actionCreators.UpdateManagerSmsNotificationSettingsSuccess(response.data)),
      put(actionCreators.GetManagerSmsNotificationSettings({ clientId: payload.clientId })),
      put(sendSuccessMessage(payload.successMessage)),
    ]);
  } catch (e) {
    yield put(actionCreators.UpdateManagerSmsNotificationSettingsError(e.response));
  }
}

// ROOT

export function* ManagerSmsSettingsSagas(): Generator<*, void, void> {
  yield all([
    takeEvery(actions.GetManagerSmsNotificationSettings, onGetManagerSmsNotificationSettings),
    takeEvery(actions.UpdateManagerSmsNotificationSettings, onUpdateManagerSmsSettings),
  ]);
}

export default ManagerSmsSettingsSagas;
